import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RespCoachLogin } from "../../models/RespCoachLogin";
import { getStorageItem } from "../../utils/localStorage";
import { IAxiosResponses } from "../../typings/AxiosRespnses";

interface MeCoachState {
  me: RespCoachLogin | undefined;
  userMe:
    | (IAxiosResponses["userLogin"] & {
        optionsGym: { value: string; label: string }[];
      })
    | undefined;
  type: "gym" | "athlete";
  selectedGym?: any;
  loading: boolean;
}

const initialState = {
  me: getStorageItem("coachMe"),
  userMe: getStorageItem("userMe"),
  type: !!getStorageItem("coachMe")
    ? "gym"
    : !!getStorageItem("userMe")
    ? "athlete"
    : undefined,
  loading: false,
  selectedGym: undefined,
} as MeCoachState;

const coachMeSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    setCoachMe(
      state: MeCoachState,
      action: PayloadAction<
        (RespCoachLogin & { type: "gym" | "athlete" }) | undefined
      >
    ) {
      state.type = "gym";
      state.me = action.payload;
    },
    setUserMe(
      state: MeCoachState,
      action: PayloadAction<MeCoachState["userMe"] | undefined>
    ) {
      state.type = "athlete";
      state.userMe = action.payload;
    },
    setSelectedGym(
      state: MeCoachState,
      action: PayloadAction<any | undefined>
    ) {
      state.selectedGym = action.payload;
    },
    setIsLoading(state: MeCoachState, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    patchCoachMe(
      state: MeCoachState,
      action: PayloadAction<Partial<RespCoachLogin["coach"]>>
    ) {
      if (!state.me?.coach) return state;
      state.me.coach = { ...state.me.coach, ...action.payload };
    },
  },
});

export const {
  setCoachMe,
  patchCoachMe,
  setUserMe,
  setIsLoading,
  setSelectedGym,
} = coachMeSlice.actions;
export default coachMeSlice.reducer;
